module.exports = __webpack_public_path__ + "media/images/flags/64/Argentina-8e21a1f29fdca41f4df08212b13ecaf4.png";